// @ts-check

require('@theia/core/lib/electron-browser/preload').preload();
require('@theia/filesystem/lib/electron-browser/preload').preload();
require('arduino-ide-extension/lib/electron-browser/preload').preload();
